export default __webpack_public_path__ + "static/media/favicon-smartpcp.93e34038.ico";